<template>
  <div class="group-detail">
    <h1 class="common__main-title">Import Course</h1>
    <div class="common__sub-title">Import</div>
    <div class="content-wrapper">
      <div class="main-content">
        <div class="main-content__csv-box">
          <p>Course csv</p>
          <FileInput v-model="selectedCsv" @changedFile="error = null" />
          <ErrorCsv :errorMessages="error" />
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <b-button
          pill
          variant="primary"
          @click="confirmUploadCsv"
        >
          Confirm
        </b-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import FileInput from '@/components/parts/inputItem/FileInput.vue'
import { readCsv, countRecords } from '@/utils/csv'
import ErrorCsv from '@/components/parts/ErrorCsv.vue'

export default Vue.extend({
  components: {
    FileInput,
    ErrorCsv,
  },

  data(): {
    selectedCsv: File|null,
    error: string[]|string|Object|null,
    isImporting: boolean,
    } {
    return {
      selectedCsv: null,
      error: null,
      isImporting: false,
    }
  },

  methods: {
    async confirmUploadCsv() {
      if (this.isImporting) {
        return
      }
      if (!this.selectedCsv) {
        this.error = 'required csv file.'
        return
      }
      this.error = null

      try {
        const reader = await readCsv(this.selectedCsv)
        const recordsCount = countRecords(reader)
        const isOk = await this.$bvModal.msgBoxConfirm(
          `Import ${recordsCount} courses. Is it OK?`,
        )

        if (isOk) {
          this.registerCourses()
        }
      } catch (error) {
        this.error = 'selected file has error. please select file again.'
        this.selectedCsv = null
      }
    },
    registerCourses() {
      this.isImporting = true

      // コースインポート処理
      this.$store.dispatch('importCoursesByCsv', this.selectedCsv)
        .then(() => {
          this.$bvModal.msgBoxOk('Success !')
          this.selectedCsv = null
        })
        .catch((error) => {
          this.error = error
        })
        .finally(() => {
          this.isImporting = false
        })
    },
  },
})
</script>

<style scoped>
.main-content {
  padding: 20px;
  border-radius: 20px;
  margin-bottom:20px;
  min-height: 500px;
}

.content-wrapper {
  background: #D8D8D8;
  padding: 20px 50px;
  min-height: 700px;
}

.main-content p {
  display: block;
  text-align: left;
  margin:10px 0;
  font-weight: bold;
  text-align: left;
  margin:10px 0;
  font-weight: bold;
}

.main-content__csv-box {
  margin-bottom:70px;
}
</style>
